<template>
  <el-dialog
    class="share-dialog"
    width="700px"
    :visible.sync="dialogVisible"
    :class="{ 'has-qrcode': showQRCode }"
  >
    <div class="dialog-title" slot="title">
      <span class="share-icon"></span>
      <span style="font-size: 20px;">{{ titleProxy }}</span>
    </div>
    <div class="flex flex-column">
      <div
        v-if="title"
        style="text-align: center; font-size: 18px; padding-bottom: 15px;"
      >
        {{ title }}
      </div>
      <div class="flex flex-row">
        <div
          class="flex-fill flex flex-column v-center"
          style="padding: 0 20px;"
        >
          <div class="flex flex-row">
            <el-input :value="shareUrl" />
            <el-button
              size="small"
              type="text"
              v-clipboard:copy="shareUrl"
              v-clipboard:success="onCopySuccess"
              v-clipboard:error="onCopyError"
              style="margin-left: 15px;"
              >复制</el-button
            >
            <a
              :href="shareUrl"
              target="_blank"
              style="
                display: inline-flex;
                text-decoration: none;
                margin-left: 5px;
              "
              ><el-button size="small" type="text">打开</el-button></a
            >
          </div>
          <div style="padding: 20px 0;">可以将链接发送给你的好友</div>
        </div>
        <el-divider v-if="showQRCode" class="split" direction="vertical" />
        <div
          v-if="showQRCode"
          class="flex-auto flex flex-column v-center h-center"
          style="text-align: center;"
        >
          <div style="text-align: center;">
            <img
              ref="image"
              :src="qrCodeProxy"
              style="width: 170px; margin-top: -20px;"
            />
          </div>
          <div>将二维码分享给好友，</div>
          <div>对方扫一扫即可填写</div>
          <el-button
            size="small"
            type="primary"
            @click="handleSave"
            style="margin-top: 20px;"
            >下载二维码</el-button
          >
          <div style="display: none;">
            <canvas ref="canvas" style="display: none;" />
            <a ref="downloader" :download="fileName" style="display: none;"></a>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="poster"
      class="flex flex-column h-center"
      style="
        position: fixed;
        bottom: 0;
        background-color: #5d9cec;
        width: 250px;
        text-align: center;
        left: -400px;
        border-radius: 15px;
        color: white;
        padding: 15px;
      "
    >
      <img
        src="@/assets/logo_512.png"
        style="width: 75px; filter: drop-shadow(2px 4px 6px black);"
      />
      <div style="font-size: 25px;">收集表</div>
      <div
        v-if="title"
        style="
          background-color: rgba(0, 0, 0, 0.1);
          padding: 5px;
          align-self: stretch;
          margin: 15px 0;
          color: #ffff0f;
          border-radius: 5px;
        "
      >
        {{ title }}
      </div>
      <img ref="posterImage" :src="qrCodeProxy" style="width: 130px;" />
      <div style="font-size: 12px;">长按或扫描二维码完成收集表</div>
      <div style="margin-top: 60px; font-size: 12px;">
        <span>--</span>
        <span style="padding: 0 5px;">由农信网提供技术支持</span>
        <span>--</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog, Button, Message, Input, Divider } from "element-ui";
import { obtainServerQrCodeUrl } from "@/utils/LinkHelper";
import html2canvas from "html2canvas";

export default {
  name: "share-qrcode-dialog",
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Input.name]: Input,
    [Divider.name]: Divider,
  },
  props: {
    showQRCode: Boolean,
    visible: Boolean,
    shareUrl: String,
    qrCode: String,
    title: String,
    uniqueId: String,
  },
  computed: {
    dialogVisible: {
      get() {
        return this.$props["visible"];
      },
      set(value) {
        if (!value) {
          this.handleClose();
        }
      },
    },
    qrCodeProxy() {
      if (this.qrCode) {
        return obtainServerQrCodeUrl(this.qrCode);
      }
      return "";
    },
    titleProxy() {
      if (this.$props.showQRCode) {
        return "保存二维码或链接，分享给你的好友";
      }
      return "复制链接，分享给你的好友";
    },
    fileName() {
      return `${this.title || this.uniqueId}.png`;
    },
  },
  methods: {
    onCopySuccess() {
      Message({
        message: "链接已成功复制到剪切板，快去给小伙伴分享吧",
        type: "success",
      });
    },
    onCopyError(e) {
      console.error(e);
      Message.error("复制失败");
    },
    handleClose() {
      this.$emit("on-close");
    },
    handleSave() {
      const { image, canvas, downloader, poster } = this.$refs;
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
      canvas.getContext("2d").drawImage(image, 0, 0);
      downloader.href = canvas.toDataURL();
      downloader.click();
      // html2canvas(poster).then((it) => {
      //   downloader.href = it.toDataURL();
      //   downloader.click();
      // });
    },
  },
};
</script>
<style>
.split.el-divider--vertical {
  height: auto;
  margin-left: 0px;
  margin-right: 0px;
}
.el-dialog__wrapper.share-dialog > .el-dialog > .el-dialog__header {
  /*margin: auto;*/
  /*width: 30px;*/
  /*height: 30px;*/
  padding: 25px;
  background-repeat: no-repeat;
  background-position: center;
  /*background-size: 50% 50%;*/
  background-image: url(../../assets/dialog-title-bg.png);
}
.el-dialog__wrapper.share-dialog > .el-dialog > .el-dialog__body {
  padding: 60px 20px 40px 20px;
}
.el-dialog__wrapper.share-dialog.has-qrcode > .el-dialog > .el-dialog__body {
  padding: 20px 0;
}
.el-dialog__wrapper.share-dialog
  > .el-dialog
  > .el-dialog__header
  > .el-dialog__headerbtn {
  top: 30px;
  right: 25px;
}
.el-dialog__wrapper.share-dialog
  > .el-dialog
  > .el-dialog__header
  > .el-dialog__headerbtn
  > .el-dialog__close.el-icon.el-icon-close {
  color: white;
}
.dialog-title {
  text-align: center;
  color: white;
}
.dialog-title > span {
  vertical-align: middle;
}
.dialog-title > .share-icon {
  display: inline-block;
  padding-right: 5px;
  margin: auto;
  width: 25px;
  height: 25px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(../../assets/share.png);
}
</style>
